module.exports = __webpack_public_path__ + "img/td_T6.2 (_Technical Index_).58f8c28a.png";